module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/components/widgets/barchart/barchart.component.scss
// module id = ./src/app/shared/components/widgets/barchart/barchart.component.scss
// module chunks = main